
export default createContext({
  dodone: null,
  startDodone: null,
  finishDodone: null,
  updateDodone: null,
  notification: null,
  onTick: null,
  invalidateQueries: null
})
